/*
 * @Author: Gang Jiang
 * @Date: 2024-09-19 15:01:11
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2026-05-28 14:43:31
 */
const API_DOMAIN = {
  // it / 本地
  it: 'apiirwd.it1.dealmoon.net',
  // st
  st: 'api.st1.inrewards.com',
  // 线上
  prod: 'api.inrewards.com',
}

/**
 * 根据当前访问 host 判断环境并返回 API 域名
 * - it / 本地: apiirwd.it1.dealmoon.net
 * - st: api.st1.inrewards.com
 * - 线上: api.inrewards.com
 */
function resolveApiDomain() {
  // Node 环境（如 vue.config.js require）没有 location，本地开发默认走 it
  if (typeof location === 'undefined' || !location?.host) {
    return API_DOMAIN.it
  }

  const host = location.host.toLowerCase()

  // 本地
  if (
    host.includes('localhost') ||
    host.startsWith('127.0.0.1') ||
    host.startsWith('0.0.0.0')
  ) {
    return API_DOMAIN.it
  }

  // it（admirwd.it1.dealmoon.net 等）
  if (host.includes('it1') || host.includes('dealmoon.net')) {
    return API_DOMAIN.it
  }

  // st（adm.st1.inrewards.com 等）
  if (host.includes('st1') || /(^|\.)st\d*\./.test(host)) {
    return API_DOMAIN.st
  }

  // 线上（adm.inrewards.com 等）
  return API_DOMAIN.prod
}

module.exports = {
  // 开发代理与生产直连均使用此域名（勿带 https://）
  apiDomain: resolveApiDomain(),
}
